module.exports = __webpack_public_path__ + "static/media/3_7.0fe0cd41.png";